// extracted by mini-css-extract-plugin
export var circle = "_99-1";
export var exitConfirmationModal = "_99-5";
export var iframe = "_99-0";
export var offline = "_99-3";
export var online = "_99-2";
export var workstationSelectError = "_99-4";